import { useEffect, useState } from "react";
import {
  Row,
  Table,
  Container,
  Button,
  Col,
  InputGroup,
  Form,
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SatAPI from "../../_services/sat";
import { getFetchParamGenerator, getApiURL } from "../../_services/sat";
import toastService from "../../_services/toastService";
import EditModal from "./EditModal";
import RemoveModal from "./RemoveModal";
import { downloadBlob } from "../../_helpers/excel";

const api = SatAPI();

function Collegas() {
  const snapshot = useSelector((state) => state.snapshot.fileName);
  const [collegas, setCollegas] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [taskAssignments, setTaskAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(null);
  const [removeModal, setRemoveModal] = useState(null);
  const { id } = useParams();
  const [search, setSearch] = useState("");
  const [generalParameters, setGeneralParameters] = useState(null);

  const loadCollegas = async () => {
    try {
      setLoading(true);

      const response = await api.getCollegasWithContactHours(snapshot);
      const assignments = await api.getAssignments(snapshot);
      setAssignments(assignments);
      const taskAssignments = await api.getTaskAssignments(snapshot);
      setTaskAssignments(taskAssignments);
      const general = await api.getGlobalSettings(snapshot);
      setGeneralParameters(general);

      if (localStorage.getItem("SAT-typeSorting") === "firstname") {
        response.sort(
          (a, b) =>
            a.firstName.localeCompare(b.firstName) ||
            a.lastName.localeCompare(b.lastName)
        );
      } else {
        response.sort(
          (a, b) =>
            a.lastName.localeCompare(b.lastName) ||
            a.firstName.localeCompare(b.firstName)
        );
      }

      setCollegas(response);
      setLoading(false);
      return response;
    } catch (error) {
      toastService.send({ title: "An error occured", message: error });
    }
    return [];
  };

  const totalVte = (collegaId) => {
    // Get distinct OLA IDs from assignments
    const uniqueOlaIds = [
      ...new Set(assignments.map((x) => x.olaID).filter(Boolean))
    ];

    // For each OLA ID, sum vte for that collega, round per OLA
    const assignmentVTE = uniqueOlaIds.reduce((total, olaID) => {
      const vteSum = assignments
        .filter((x) => x.collegaID == collegaId && x.olaID == olaID)
        .reduce((n, { vte }) => n + vte, 0);
      return total + Math.round(vteSum * 2) / 2;
    }, 0);

    const taskAssignmentVTE = taskAssignments
      .filter((x) => x.collegaID == collegaId)
      .reduce((n, { vte }) => n + vte, 0);

    const forfait = Math.round(
      (
        taskAssignments
          .filter((x) => x.collegaID == collegaId)
          .reduce((n, { forfait }) => n + forfait, 0) +
        uniqueOlaIds.reduce((total, olaID) => {
          return (
            total +
            assignments
              .filter((x) => x.collegaID == collegaId && x.olaID == olaID)
              .reduce((n, { forfait }) => n + forfait, 0)
          );
        }, 0)
      ) * 2
    ) / 2;

    return assignmentVTE + taskAssignmentVTE + forfait;
  };

  const filter = (list) =>
    list.filter((c) => {
      if (search === "") {
        return true;
      }
      return `${c.firstName} ${c.lastName} ${c.firstName} ${c.initials} ${c.nameOrangeGuide}`
        .toLowerCase()
        .includes(search.toLowerCase()); // clever trick to search on first and last name
    });

  const openModal = (data) => {
    setEditModal(
      <EditModal
        hideModal={() => {
          setEditModal(null);
          loadCollegas();
        }}
        data={data}
      />
    );
  };

  const openRemoveModal = (collega) => {
    setRemoveModal(
      <RemoveModal
        hideModal={() => {
          setRemoveModal(null);
          loadCollegas();
        }}
        data={collega}
      />
    );
  };

  const exportData = async () => {
    try {
      const { fetchParamCreator, fetch } = getFetchParamGenerator();
      const opts = fetchParamCreator.getCollegasExport(snapshot, {});
      const resp = await fetch(getApiURL() + opts.url, opts.options);
      // download content as a file in new tab
      const file = await resp.blob();
      downloadBlob(file, "collegas.xlsx");
    } catch (resp) {
      console.log(resp);
    }
  };

  useEffect(() => {
    loadCollegas().then((resp) => {
      if (id) {
        console.log("ID: ", id, collegas);
        const collega = resp.find(
          (c) => parseInt(c.ID, 10) === parseInt(id, 10)
        );
        console.log("Collega: ", collega);
        if (collega) {
          openModal(collega);
        }
      }
    });
  }, [snapshot]);

  const popover = () => (
    <Popover>
      <Popover.Header as="h3">Legende</Popover.Header>
      <Popover.Body>
        <h5>Symbolen</h5>
        <p>
          <span className="text-warning">
            <i className="far fa-snooze" />
          </span>{" "}
          Inactieve collega
        </p>
        <p>
          <span className="text-info">
            <i className="far fa-comment-dots" />
          </span>{" "}
          Opmerking aanwezig
        </p>
        <p>
          <span className="text-danger">
            <i className="far fa-times-circle" />
          </span>{" "}
          Geen forfait
        </p>
        <p>
          <span className="text-tertiary">
            <i className="far fa-user-cog" />
          </span>{" "}
          SAT-gebruiker
        </p>
        <p>
          <span className="text-danger">
            <i className="fas fa-flag" />
          </span>{" "}
          Veld &apos;OK unit?&apos; ingevuld
        </p>
      </Popover.Body>
    </Popover>
  );

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }
  return (
    <Container>
      {editModal}
      {removeModal}
      <Row>
        <h1>Docenten</h1>
      </Row>
      <Row className="my-2">
        <Col className="text-begin">
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">
              <i className="fas fa-search" />
            </InputGroup.Text>
            <Form.Control
              type="text"
              required
              onChange={(e) => setSearch(e.target.value, 10)}
              value={search}
            />
          </InputGroup>
        </Col>
        <Col>
          <div className="float-end fixedElement">
            <OverlayTrigger
              trigger="click"
              placement="left"
              overlay={popover()}
            >
              <Button variant="info" className="me-2">
                <i className="fas fa-question" />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
        <Col className="text-end">
          <Button variant="secondary" onClick={() => exportData()}>
            <i className="far fa-file-export" /> Exporteren
          </Button>{" "}
          <Button
            variant="success"
            onClick={() => openModal()}
            disabled={snapshot}
          >
            <i className="far fa-plus" />
            &nbsp;Nieuw
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Voornaam</th>
                <th>Achternaam</th>
                <th>Verlofstelsel</th>
                <th>% in unit</th>
                <th>
                  <Table striped className="table-contactHours">
                    <thead>
                      <tr>
                        <th>Q1</th>
                        <th>Q2</th>
                        <th>Q3</th>
                        <th>Q4</th>
                      </tr>
                    </thead>
                  </Table>
                </th>
                <th>VTE %</th>
                <th>Kleur</th>
                <th className="text-transparent">&nbsp;.</th>
              </tr>
            </thead>
            <tbody>
              {filter(collegas).map((collega) => (
                <tr key={collega.id}>
                  <td>
                    {collega.isSATUser && (
                      <span className="text-tertiary">
                        <i className="far fa-user-cog" />
                        &nbsp;
                      </span>
                    )}
                    {collega.isInactive && (
                      <span className="text-warning">
                        <i className="far fa-snooze" />
                        &nbsp;
                      </span>
                    )}
                    {collega.comments !== "" && (
                      <span className="text-info">
                        <i className="far fa-comment-dots" />
                        &nbsp;
                      </span>
                    )}
                    {collega.noForfait && (
                      <span className="text-danger">
                        <i className="far fa-times-circle" />
                        &nbsp;
                      </span>
                    )}
                    {collega.firstName}
                  </td>
                  <td>{collega.lastName}</td>
                  <td>{collega.leaveSchedule}</td>
                  <td>{collega.percentageInUnit}</td>
                  <td>
                    <Table striped className="table-contactHours">
                      <tbody>
                        <tr>
                          <td className="contactHours">
                            {collega.contactHours.contactHoursQ1 >
                              generalParameters.limitContactHours ? (
                              <strong className="text-danger">
                                {collega.contactHours.contactHoursQ1}
                              </strong>
                            ) : (
                              collega.contactHours.contactHoursQ1
                            )}
                          </td>
                          <td className="contactHours">
                            {collega.contactHours.contactHoursQ2 >
                              generalParameters.limitContactHours ? (
                              <strong className="text-danger">
                                {collega.contactHours.contactHoursQ2}
                              </strong>
                            ) : (
                              collega.contactHours.contactHoursQ2
                            )}
                          </td>
                          <td className="contactHours">
                            {collega.contactHours.contactHoursQ3 >
                              generalParameters.limitContactHours ? (
                              <strong className="text-danger">
                                {collega.contactHours.contactHoursQ3}
                              </strong>
                            ) : (
                              collega.contactHours.contactHoursQ3
                            )}
                          </td>
                          <td className="contactHours">
                            {collega.contactHours.contactHoursQ4 >
                              generalParameters.limitContactHours ? (
                              <strong className="text-danger">
                                {collega.contactHours.contactHoursQ4}
                              </strong>
                            ) : (
                              collega.contactHours.contactHoursQ4
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                  <td>
                    <span
                      className={
                        (totalVte(collega.ID) <
                          collega.percentageInUnit -
                          collega.leaveSchedule -
                          generalParameters.allowedDeviation ||
                          totalVte(collega.ID) >
                          collega.percentageInUnit -
                          collega.leaveSchedule +
                          generalParameters.allowedDeviation) &&
                        "font-bold text-danger"
                      }
                    >
                      {totalVte(collega.ID)}
                    </span>{" "}
                    {collega.fundingSource !== "" &&
                      collega.fundingSource !== null && (
                        <span className="text-danger">
                          <i className="fas fa-flag" />
                          &nbsp;
                        </span>
                      )}
                  </td>
                  <td
                    style={{ backgroundColor: collega.color }}
                    className="text-transparent"
                  >
                    .
                  </td>
                  <td className="text-end">
                    <Button variant="info" onClick={() => openModal(collega)}>
                      <i className="far fa-edit" />
                    </Button>{" "}
                    <Button
                      variant="danger"
                      onClick={() => openRemoveModal(collega)}
                      disabled={snapshot}
                    >
                      <i className="far fa-trash" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

export default Collegas;
